import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/page-hero";
import { Section } from "@/components/section";
import { AnimatedGallery } from "@/components/animated-gallery";
import { CtaBand } from "@/components/cta-band";
import { lcpPreload } from "@/lib/images";
import { GALLERY } from "@/lib/site-data";

export const Route = createFileRoute("/gallery")({
  head: () => ({
    meta: [
      { title: "Framing Gallery | Magnolia House, Fuquay-Varina NC" },
      {
        name: "description",
        content:
          "Jerseys, flags, medals, coins, diplomas, restored photographs and shadow boxes framed at Magnolia House in Fuquay-Varina, NC.",
      },
      {
        property: "og:title",
        content: "Framing Gallery | Magnolia House Custom Picture Framing",
      },
      {
        property: "og:description",
        content:
          "A look at finished work from thirty-five years of custom framing in Fuquay-Varina.",
      },
    ],
    links: [lcpPreload("framed-jersey-medal")],
  }),
  component: GalleryPage,
});

function GalleryPage() {
  return (
    <>
      <PageHero
        eyebrow="Framing gallery"
        title={
          <>
            Finished work,
            <br />
            <span className="amber-text italic">still hanging</span> years later.
          </>
        }
        lead="Click any piece to see it full size. Each of these started as something someone was afraid to hand over."
        image="framed-jersey-medal"
        alt="Framed jersey, medal and photograph"
      />

      <Section>
        <AnimatedGallery items={GALLERY} />
      </Section>

      <CtaBand />
    </>
  );
}
